/** CSS viewport pixels, not device inches or physical display resolution. */
export function workspaceScale(width: number, height: number, touch: boolean = false): number {
  if (width <= 740) return 1; // Existing phone layout is handled separately.
  const minimum = touch ? 0.9 : 0.85;
  return Math.round(Math.max(minimum, Math.min(width / 1600, height / 900, 1)) * 100) / 100;
}
